import Spinner from '../components/Spinner'

export default function LoadingPage() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner />
    </div>
  )
}
